import React from 'react';
import { hydrate } from 'react-dom';
import HeaderScaffold from '../app/scaffold/Header';

const init = initialState => {
  const headerAppEl = document.getElementById('root');

  if (headerAppEl) {
    hydrate(<HeaderScaffold initialState={initialState} />, headerAppEl);
  }
};

const fetchInitialState = () =>
  fetch(`/header/api/state`).then(async response => {
    const initialState = await response.json();
    init(initialState);
  });

const loadInitialState = () => {
  /* eslint-disable-next-line no-underscore-dangle */
  const preloadedState = window.__PRELOADED_STATE__;
  if (!preloadedState) {
    return fetchInitialState();
  }
  return init(preloadedState);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadInitialState);
} else {
  loadInitialState();
}
